<template>
    <v-expansion-panel
        v-if="hasItems"
        expand
        :class="containerClass"
        class="app-expand-card"
    >
        <v-expansion-panel-content>
            <div slot="header">
                <v-list dense>
                    <v-list-tile>
                        <v-list-tile-content>
                            <b class="print-field"><slot name="header"/> </b>
                        </v-list-tile-content>
                        <v-list-tile-content v-if="!onlyTitle" class="align-end" > <b> <h3 class="print-field"> {{ value | localeAmount }} </h3> </b> </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </div>
            <v-list dense v-if="hasItems" class="no-padding">  
                <slot name="items" />
            </v-list>
        </v-expansion-panel-content>
    </v-expansion-panel>
    <v-list-tile v-else class="app-expand-card">
        <v-list-tile-content>
            <b><h3 class="print-field"><slot name="header" /></h3> </b>
        </v-list-tile-content>
        <v-list-tile-content v-if="!onlyTitle" class="align-end" > <b> <h3> <h3 class="print-field"> {{ value | localeAmount }} </h3> </h3> </b> </v-list-tile-content>
    </v-list-tile>
</template>
<script>
export default {
    name: 'ExpandCard',
    props: {
        onlyTitle: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            default: () => 0,
        },
        hasItems: {
            type: Boolean,
            default: false
        },
        containerClass: {
            type: String,
            default: () => ''
        }
    },
    methods: {
        handleClick(e) {
            e.stopPropagation();
            // e.preventDefault();
            console.info('lol')
        }
    }
}
</script>
<style scoped>
.app-expand-card {
    margin-bottom: 5px;
}
.app-expand-card .no-padding {
    padding: 0;
}
.app-expand-card.no-shadow {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/Bsheet/expandCard.vue